export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20bedroom%20scene%20with%20warm%20lighting%2C%20laptop%20on%20bed%20showing%20movie%20streaming%20interface%20with%20glowing%20screen%2C%20soft%20blankets%20and%20pillows%2C%20popcorn%20bowl%20nearby%2C%20evening%20ambiance%20with%20fairy%20lights%2C%20comfortable%20home%20cinema%20vibe%2C%20warm%20golden%20and%20crimson%20tones&width=800&height=600&seq=about-beiwo&orientation=landscape"
                alt="被窝网电影 - 舒适居家观影场景"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <p className="text-xs font-semibold text-accent-600 tracking-widest uppercase mb-3">About Us</p>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              关于被窝网电影
            </h2>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                被窝网电影诞生于影迷对高品质观影体验的追求。我们深知，最好的观影体验往往发生在最放松的时刻——窝在被窝里，打开一部好电影，让光影故事陪伴每一个夜晚。
              </p>
              <p>
                作为一站式影视资源聚合平台，被窝电影网大全每日精选全网优质片源，涵盖动作、喜剧、科幻、爱情、悬疑、动画等全品类内容。我们坚持免费、高清、不缓冲的服务理念，让每一位用户都能享受流畅的观影体验。
              </p>
              <p>
                平台持续追踪全球影视动态，从院线新片到经典老片，从国产精品到海外佳作，被窝网电影用专业的内容筛选和稳定的播放技术，构筑起千万影迷信赖的在线观影家园。
              </p>
            </div>

            <div className="flex flex-wrap gap-4 mt-8">
              {['海量片库', '高清画质', '极速加载', '每日更新'].map((tag) => (
                <span key={tag} className="px-4 py-2 bg-background-50 border border-background-200/60 rounded-full text-xs font-medium text-foreground-600 whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}